import { api } from "./client";

export interface Product {
  id: string;
  tenant_id: string;
  name: string;
  description: string | null;
  reference: string | null;
  sale_price_ht: string;
  vat_rate: string;
  sale_price_ttc: string;
  purchase_price: string | null;
  currency: string;
  unit: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ProductCreate {
  name: string;
  description?: string | null;
  reference?: string | null;
  sale_price_ht: number;
  vat_rate: number;
  sale_price_ttc: number;
  purchase_price?: number | null;
  currency: string;
  unit?: string | null;
  is_active?: boolean;
}

export type ProductUpdate = Partial<ProductCreate>;

export interface ProductListResponse {
  total: number;
  items: Product[];
}

export const productsApi = {
  list: (params?: { active_only?: boolean; q?: string }) => {
    const qs = new URLSearchParams();
    if (params?.active_only !== undefined) qs.set("active_only", String(params.active_only));
    if (params?.q) qs.set("q", params.q);
    const query = qs.toString();
    return api.get<ProductListResponse>(`/api/products${query ? `?${query}` : ""}`);
  },
  create: (data: ProductCreate) => api.post<Product>("/api/products", data),
  update: (id: string, data: ProductUpdate) => api.patch<Product>(`/api/products/${id}`, data),
  delete: (id: string) => api.delete<void>(`/api/products/${id}`),
};
